// extracted by mini-css-extract-plugin
export default {"stepsList":"style_stepsList__1jCb8","stepWrapper":"style_stepWrapper__pnYai","stepNumber":"style_stepNumber__MLF93","stepContent":"style_stepContent__IILnr"};